import {
	getFlattenContacts,
	getUniqueContacts
} from '../../components/Pages/ContactDB/Toolbar/GenerateMessage/GMForm/utils/normalizeFilters';
import {getKeyContactsFromContacts} from '../../util/contactsDB';

export default (entities) => {
	const uniqueContacts = getUniqueContacts(getFlattenContacts(entities));
	return getKeyContactsFromContacts(uniqueContacts).length;
};
